import { render, staticRenderFns } from "./RoomsItemButtons.vue?vue&type=template&id=1b07b81e&scoped=true&"
import script from "./RoomsItemButtons.vue?vue&type=script&lang=js&"
export * from "./RoomsItemButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07b81e",
  null
  
)

export default component.exports